export default "__VITE_ASSET__lAb$ZIsm__"